import { useMemo } from "react";

const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default function useEmailValidation(email: string) {
  const hasValidEmail = useMemo(() => {
    return EMAIL_REGEX.test(email);
  }, [email]);

  return [hasValidEmail];
}
